export default function ({ $gtm, route }) {
  $gtm.init(process.env.GOOGLE_MEASUREMENT_ID)
}
